import React from 'react';
import { useSeoHead } from '../hooks/useSeoHead';
import {
  ARTICLE_TOPICS,
  ARTICLES_OVERVIEW,
  ARTICLES_UI,
  breadcrumbJsonLd,
  hreflangPair,
  overviewCrumbs,
  overviewJsonLd,
  type ArticleLang,
} from '../articles';
import { SITE_URL } from '../seoRoutes';
import { ArticleCard, Breadcrumb, FitCheckBox } from '../components/articles/ArticleParts';

// Articles overview ("Artikel" / "Articles") at /de/guides/ and /en/guides/.
// Tiles come from src/articles.ts — one per published topic, in topic order.
export function overviewHeadJsonLd(lang: ArticleLang) {
  return [overviewJsonLd(lang), breadcrumbJsonLd(overviewCrumbs(lang), ARTICLES_OVERVIEW[lang].path)];
}

export const GuidesOverview: React.FC<{ lang: ArticleLang }> = ({ lang }) => {
  const o = ARTICLES_OVERVIEW[lang];
  useSeoHead({
    title: o.title,
    description: o.description,
    canonical: `${SITE_URL}${o.path}`,
    indexable: true,
    htmlLang: lang,
    hreflang: hreflangPair(ARTICLES_OVERVIEW.de.path, ARTICLES_OVERVIEW.en.path),
    jsonLd: overviewHeadJsonLd(lang),
  });

  return (
    <div className="pt-28 pb-24">
      <div className="container mx-auto px-6 max-w-6xl">
        <Breadcrumb crumbs={overviewCrumbs(lang)} lang={lang} />

        <h1 className="text-4xl sm:text-5xl font-display font-bold text-pstax-navy mb-6 leading-tight max-w-3xl">
          {o.h1}
        </h1>
        <p className="text-xl text-pstax-gray leading-relaxed mb-12 max-w-3xl">{o.intro}</p>

        <div className="grid md:grid-cols-2 gap-6">
          {ARTICLE_TOPICS.map((topic) => (
            <ArticleCard key={topic.key} topic={topic} lang={lang} />
          ))}
        </div>

        <p className="mt-8 text-sm text-pstax-gray">{ARTICLES_UI[lang].moreSoon}</p>

        <FitCheckBox lang={lang} />
      </div>
    </div>
  );
};
